// exp_PORTFOLIO-58018_file
import { FC } from 'react';

import { SPACE } from 'utils/constants/common';
import { MIN_BUDGET, MIN_RESPONSES, ONE_RESPONSE_PRICE, RESPONSES_INPUT_STEP } from 'utils/vrCampaign';

import vrPackageFormFieldTouch from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/vr_package/vr_package_form_field_touch';
import { Button, Flex, NumberInput, Text } from '@hh.ru/magritte-ui';
import { MinusOutlinedSize24, PlusOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import {
    selectVrCampaignErrors,
    selectVrCampaignResponses,
    setVrCampaignBudget,
    setVrCampaignErrors,
    setVrCampaignResponses,
} from 'store/models/vrCampaign';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'VrCampaignBuilderPage.responses.title',
    error: 'VrCampaignBuilderPage.responses.error',
};

export const Responses: FC = () => {
    const trls = useTrls();
    const dispatch = useDispatch();

    const responses = useSelector(selectVrCampaignResponses);
    const hasError = useSelector(selectVrCampaignErrors).responses;

    const validateLinkedFields = (nextResponses: number, nextBudget: number) => {
        dispatch(
            setVrCampaignErrors({
                responses: nextResponses < MIN_RESPONSES,
                budget: nextBudget < MIN_BUDGET,
            })
        );
    };

    const handleBlur = () => {
        const nextBudget = Number(responses) * ONE_RESPONSE_PRICE;
        validateLinkedFields(Number(responses), nextBudget);
        vrPackageFormFieldTouch({ fieldName: 'responses_count', responsesCount: Number(responses) });
    };

    const handleResponsesChange = (value: string) => {
        const nextResponses = Number(value);
        const nextBudget = nextResponses * ONE_RESPONSE_PRICE;

        validateLinkedFields(nextResponses, nextBudget);
        dispatch([setVrCampaignResponses(nextResponses), setVrCampaignBudget(nextBudget)]);
    };

    const handleStep = (nextValue: number) => {
        const clampedValue = Math.max(0, nextValue);
        handleResponsesChange(String(clampedValue));
        vrPackageFormFieldTouch({ fieldName: 'responses_count', responsesCount: clampedValue });
    };

    return (
        <Flex direction="column" gap={12} grow={1} basis={0}>
            <Text>{trls(TrlKeys.title)}</Text>
            <Flex direction="row" gap={12} align="start">
                <NumberInput
                    errorMessage={hasError ? trls(TrlKeys.error) : null}
                    invalid={hasError}
                    value={String(responses)}
                    onChange={handleResponsesChange}
                    onFocus={() => dispatch(setVrCampaignErrors({ responses: false, budget: false }))}
                    onBlur={handleBlur}
                    groupSeparator={SPACE}
                    decimalLength={0}
                    allowNegative={false}
                    data-qa="vr-campaign-responses-input"
                />
                <Flex direction="row" gap={8}>
                    <Button
                        mode="secondary"
                        style="neutral"
                        size="medium"
                        hideLabel
                        icon={<MinusOutlinedSize24 />}
                        onClick={() => {
                            handleStep(responses - RESPONSES_INPUT_STEP);
                        }}
                        data-qa="vr-campaign-responses-decrease"
                    />
                    <Button
                        mode="secondary"
                        style="neutral"
                        size="medium"
                        hideLabel
                        icon={<PlusOutlinedSize24 />}
                        onClick={() => {
                            handleStep(responses + RESPONSES_INPUT_STEP);
                        }}
                        data-qa="vr-campaign-responses-increase"
                    />
                </Flex>
            </Flex>
        </Flex>
    );
};
